import { motion } from 'framer-motion';
import { useState } from 'react';

import { Checkbox } from 'antd';
import { ChevronDown } from 'lucide-react';

import { TCategory } from '../../components/types';

interface StoreFiltersProps {
  categoryId: null | number;
  handleCategoryChange: (id: number) => void;
  servicesFilter: boolean;
  categoryFilter?: boolean
  isPickup?: boolean;
  isDelivery?: boolean;
  handleServiceChange?: (service: 'isDelivery' | 'isPickup') => void;
  handleClearFilters: () => void;
  allCategories: TCategory[];
  minimumCategories: TCategory[];
}

export default function StoreFilters({
  categoryId,
  handleCategoryChange,
  servicesFilter,
  categoryFilter = true,
  isDelivery,
  isPickup,
  handleServiceChange,
  handleClearFilters,
  allCategories,
  minimumCategories,
}: StoreFiltersProps) {
  const [type, setType] = useState(true);
  const [services, setServices] = useState(true);
  const [categories, setCategories] = useState<TCategory[]>(minimumCategories);

  function handleNumOfCatgories() {
    if (categories.length > 10) {
      setCategories(minimumCategories);
    } else {
      setCategories(allCategories);
    }
  }

  return (
    <div className="hidden h-full md:flex flex-col col-span-1">
      <div className="relative z-0 after:w-1 after:h-2.5 after:absolute after:z-10 after:bottom-[1px] after:-right-[1px] after:bg-white">
        <div className="h-14 px-4 flex justify-between items-center border border-l-none border-t-none border-solid border-neutral-200">
          <span className="font-manrope text-sm text-neutral-800 font-semibold">Filters</span>
          <button
            type="button"
            onClick={handleClearFilters}
            className="text-sm text-brand font-manrope font-semibold hover:cursor-pointer">
            Clear All
          </button>
        </div>
      </div>

      <div className="h-full p-4 relative z-0 space-y-4 after:w-1 after:h-2.5 after:absolute after:z-10 after:top-0 after:-right-[1px] after:bg-white border border-t-none border-b-none border-l-none border-solid border-neutral-200">
        {categoryFilter && <div className="space-y-2.5">
          <button
            type="button"
            onClick={() => setType(!type)}
            className="w-full px-0 flex justify-between items-center hover:cursor-pointer">
            <span className="text-sm text-neutral-800 font-manrope font-semibold">Type</span>
            <ChevronDown
              className={`w-3 h-3 text-neutral-600 transition-all duration-200 
                ${type ? 'rotate-180' : 'rotate-0'}
              `}
            />
          </button>

          <motion.div
            animate={{ maxHeight: type ? 1000 : 0, overflow: 'hidden' }}
            className='space-y-2 relative z-0 overflow-hidden'
          >
            {categories.length ? (
              categories?.map((category) => (
                <button
                  key={category.id}
                  type="button"
                  onClick={() => handleCategoryChange(category.id)}
                  className='px-0 flex items-center gap-2 cursor-pointer'
                >
                  <Checkbox checked={categoryId === category.id} />
                  <span className="text-sm text-start text-neutral-600 font-manrope font-medium">
                    {category.name}
                  </span>
                </button>
              ))
            ) : (
              minimumCategories?.map((category) => (
                <button
                  key={category.id}
                  type="button"
                  onClick={() => handleCategoryChange(category.id)}
                  className='px-0 flex items-center gap-2 cursor-pointer'
                >
                  <Checkbox checked={categoryId === category.id} />
                  <span className="text-sm text-start text-neutral-600 font-manrope font-medium">
                    {category.name}
                  </span>
                </button>
              ))
            )}

            <button
              type="button"
              onClick={handleNumOfCatgories}
              className='w-fit py-2 px-0 cursor-pointer'
            >
              <span className="text-xs text-neutral-800 font-manrope font-semibold underline underline-offset-2 uppercase">
                {categories.length > 10 ? 'Show Less' : (allCategories.length < 10 ? '' : 'Show More')}
              </span>
            </button>
          </motion.div>
        </div>}

        {servicesFilter && (
          <div className="space-y-2.5">
            <button
              type="button"
              onClick={() => setServices(!services)}
              className="w-full px-0 flex justify-between items-center hover:cursor-pointer">
              <span className="text-sm text-neutral-800 font-manrope font-semibold">Services</span>
              <ChevronDown
                className={`w-3 h-3 text-neutral-600 transition-all duration-200 
                  ${services ? 'rotate-180' : 'rotate-0'}
                `}
              />
            </button>

            <motion.div
              animate={{ maxHeight: services ? 1000 : 0, overflow: 'hidden' }}
              className='space-y-2 relative overflow-hidden'
            >
              <button
                type="button"
                onClick={() => handleServiceChange('isDelivery')}
                className='px-0 flex items-center gap-2 cursor-pointer'
              >
                <Checkbox
                  checked={isDelivery}
                />
                <span className="text-sm text-start text-neutral-600 font-manrope font-medium">
                  Delivery
                </span>
              </button>
              <button
                type="button"
                onClick={() => handleServiceChange('isPickup')}
                className='px-0 flex items-center gap-2 cursor-pointer'
              >
                <Checkbox
                  checked={isPickup}
                />
                <span className="text-sm text-start text-neutral-600 font-manrope font-medium">
                  Pickup
                </span>
              </button>
            </motion.div>
          </div>
        )}
      </div>
    </div>
  );
}
